import { render, staticRenderFns } from "./FormAssessmentGroups.vue?vue&type=template&id=225d7d5e"
import script from "./FormAssessmentGroups.vue?vue&type=script&lang=js"
export * from "./FormAssessmentGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports